import {
    NinchatStoreUser, NinchatStoreUserChannel,
} from 'api/types/store'
import {NinchatChannelAttributes} from '../../api/types/attributes'

export type ChannelUpload = NinchatChannelAttributes['upload'] | 'agent';

export const isAudienceChannel = (userChannel: NinchatStoreUserChannel): boolean => Boolean(userChannel?.channel_attrs?.audience_id)
export const isChannelClosed = (userChannel: NinchatStoreUserChannel): boolean => userChannel?.channel_attrs?.closed === true
export const isChannelSuspended = (userChannel: NinchatStoreUserChannel): boolean => userChannel?.channel_attrs?.suspended === true
export const isDescribed = (userChannel: NinchatStoreUserChannel): boolean => !!userChannel?.channel_members
export const isScheduledAppointment = (userChannel: NinchatStoreUserChannel): boolean => Boolean(userChannel?.channel_attrs?.audience?.begin_timestamp)
export const isVideoChannel = (userChannel: NinchatStoreUserChannel): boolean => userChannel?.channel_attrs?.video === 'group'
// get a list of user ids that are not operators or moderators
export const getChannelUsers = (userChannel: NinchatStoreUserChannel): Array<string> => {
    const channelMembers = Object.entries(userChannel?.channel_members ?? {})
        .filter(([_, value]) => !value.member_attrs?.operator && !value.member_attrs?.moderator)
        .map(([user_id]) => user_id)

    if (userChannel?.channel_attrs?.requester_id) {
        channelMembers.push(userChannel.channel_attrs.requester_id)
    }
    return channelMembers
}
export const getAudienceChannelUserId = (userChannel: NinchatStoreUserChannel): string | undefined => {
    const channelMembers = getChannelUsers(userChannel)
    return channelMembers?.[0]
}
export const userDisconnected = (user: NinchatStoreUser): void => {
    if (user?.user_attrs) {
        user.user_attrs.connected = false
    }
}
export const shouldShowAttachment = ({
    isAdmin, isDialogue, upload, isModerator, isOperator,
}: {isAdmin: boolean, isDialogue: boolean, isModerator: boolean, isOperator: boolean} & {upload: ChannelUpload}): boolean => {
    if (isDialogue) {
        return isAdmin
    }

    // In channel, when upload is `moderator`,
    //  - the attachment button should be displayed to moderators and operators.
    const hasModeratorLikeRole = isModerator || isOperator
    switch (upload) {
        case 'agent':
        case 'moderator': // Since we convert "agent" to "moderator" in queue-to-channel inheritance, fallback for "agent"
            return hasModeratorLikeRole
        case 'operator':
            return isOperator
        case 'member':
            return true
        default:
            return false
    }
}
